<div class="p-6">
  <div class="mb-6">
    <h2 class="mb-4 text-lg font-semibold text-gray-800">Your Accessible Syllabuses</h2>

    @if (state.accessibleSyllabuses.length > 0) {
      <div class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        @for (syllabus of state.accessibleSyllabuses; track syllabus.id) {
          <a
            [routerLink]="getSyllabusRoute(syllabus)"
            class="group block rounded-lg border border-gray-200 p-4 transition-colors hover:border-sky-300 hover:bg-sky-50"
          >
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h3 class="font-semibold text-gray-900 group-hover:text-sky-700">
                  {{ syllabus.name }}
                </h3>
                <div class="mt-2 flex items-center text-xs text-gray-400">
                  @if (syllabus.program.icon) {
                    <dojo-icon [icon]="syllabus.program.icon" [size]="12" class="mr-1" />
                  }
                  <span>{{ syllabus.program.full_name || syllabus.program.short_name }}</span>
                </div>
              </div>

              <dojo-icon
                [icon]="'arrow-right'"
                [size]="16"
                class="text-gray-400 transition-colors group-hover:text-sky-500"
              />
            </div>

            <!-- Review Work Chips -->
            @if (getReviewCounts(syllabus.id); as counts) {
              @if (getGrandTotal(counts) > 0) {
                <div class="mt-4">
                  <!-- Collapsible Header -->
                  <button
                    (click)="toggleExpanded($event, syllabus.id)"
                    class="flex w-full items-center gap-2 text-left text-sm font-medium text-gray-700 transition-colors hover:text-gray-900"
                  >
                    <dojo-icon
                      [icon]="isExpanded(syllabus.id) ? 'chevron-down' : 'chevron-right'"
                      [size]="14"
                      class="text-gray-500 transition-transform"
                    />
                    <span>To Dos</span>
                    <span class="rounded-full bg-red-500 px-2 py-0.5 text-xs font-semibold text-white">
                      {{ getGrandTotal(counts) }}
                    </span>
                  </button>

                  <!-- Expanded Content -->
                  @if (isExpanded(syllabus.id)) {
                    <div class="mt-3 flex flex-col gap-3">
                      <!-- Reference Questions Chips -->
                      @if (getTotalCount(counts.referenceQuestions) > 0) {
                        <div class="flex flex-col gap-1.5">
                          <span class="text-xs font-medium text-gray-500">
                            <b>{{ getTotalCount(counts.referenceQuestions) }}</b> To dos in Reference Questions
                          </span>
                          <div class="flex flex-wrap gap-1.5">
                            @for (item of counts.referenceQuestions; track item.type) {
                              @if (item.count > 0) {
                                <button
                                  (click)="navigateToReview($event, syllabus, item.type, true)"
                                  [matTooltip]="item.displayName"
                                  class="flex items-center gap-1.5 rounded-full border border-gray-300 bg-gray-100 px-3 py-1.5 text-xs transition-all hover:border-sky-400 hover:bg-sky-100"
                                >
                                  <dojo-icon [icon]="item.icon" [size]="14" class="text-gray-700" />
                                  <span class="font-semibold text-gray-800">{{ item.count }}</span>
                                </button>
                              }
                            }
                          </div>
                        </div>
                      }

                      <!-- Derivative Questions Chips -->
                      @if (getTotalCount(counts.derivativeQuestions) > 0) {
                        <div class="flex flex-col gap-1.5">
                          <span class="text-xs font-medium text-gray-500">
                            <b>{{ getTotalCount(counts.derivativeQuestions) }}</b> To dos in Derivative Questions
                          </span>
                          <div class="flex flex-wrap gap-1.5">
                            @for (item of counts.derivativeQuestions; track item.type) {
                              @if (item.count > 0) {
                                <button
                                  (click)="navigateToReview($event, syllabus, item.type, false)"
                                  [matTooltip]="item.displayName"
                                  class="flex items-center gap-1.5 rounded-full border border-gray-300 bg-gray-100 px-3 py-1.5 text-xs transition-all hover:border-sky-400 hover:bg-sky-100"
                                >
                                  <dojo-icon [icon]="item.icon" [size]="14" class="text-gray-700" />
                                  <span class="font-semibold text-gray-800">{{ item.count }}</span>
                                </button>
                              }
                            }
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            }
          </a>
        }
      </div>
    } @else {
      <div class="rounded-lg border border-gray-200 p-6 text-center">
        <dojo-icon [icon]="'exclamation-circle'" [size]="24" class="mx-auto mb-2 text-gray-400" />
        <p class="text-gray-600">No accessible syllabuses found.</p>
        <p class="text-sm text-gray-500">Please contact your administrator for access.</p>
      </div>
    }
  </div>
</div>
